import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=fb9c7046&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=fb9c7046&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9c7046",
  null
  
)

export default component.exports